import { ContentfulContentArticleTemplate } from '@typings/contentful-content-article-template'
import { createContext } from 'react'

export const ContentArticleTemplateContext =
  createContext<ContentfulContentArticleTemplate>(
    ContentfulContentArticleTemplate.DEFAULT
  )
